import {ContainerModule, interfaces} from "inversify";
import {TypesUI} from "@dp-instant/interfaces";
import {GamePlayScreen} from "@game/ui/screens/GamePlayScreen";
import {StartScreen} from "@game/ui/screens/StartScreen";
import {WinStagePopup} from "@game/ui/popups/WinStagePopup";
import {LosePopup} from "@game/ui/popups/LosePopup";
import {PopupType} from "./PopupType";
import {ConfirmPopup} from "@game/ui/popups/ConfirmPopup";
import {GiftPopup} from "@game/ui/popups/GiftPopup";
import {OfflineEarningsPopup} from "@game/ui/popups/OfflineEarningsPopup";
import {LeaderboardScreen} from "@game/ui/screens/LeaderboardScreen";
import {BattleResultsPopup} from "@game/ui/popups/battle-results/BattleResultsPopup";
import {ShareLevelResultPopup} from "@game/ui/popups/SharePopup";
import {SettingsPopup} from "./popups/SettingsPopup";
import {PaymentMethodPopup} from "./popups/PaymentMethodPopup";
import {NoAdsPurchasePopup} from "./popups/NoAdsPurchasePopup";
import {ReferralGiftPopup} from "./popups/ReferralGiftPopup";
import {DailyLeaderboardRewardPopup} from "./popups/DailyLeaderboardRewardPopup";
import {ShopScreen} from "@game/ui/screens/ShopScreen";
import {ReferralScreen} from "@game/ui/screens/ReferralScreen";
import {TypesGame} from "@game/TypesGame";

export const GameUIModule = new ContainerModule(
    (bind: interfaces.Bind, unbind, isBound, rebind) => {
        bind(TypesUI.screen.GAMEPLAY).toConstantValue(GamePlayScreen);
        bind(TypesUI.screen.HOME).toConstantValue(StartScreen);
        bind(TypesUI.screen.LEADERBOARD).toConstantValue(LeaderboardScreen);
        bind(TypesUI.screen.SHOP).toConstantValue(ShopScreen);

        // bind popups
        bind(PopupType.WIN_LEVEL).toConstantValue(WinStagePopup);
        bind(PopupType.WIN_STAGE).toConstantValue(WinStagePopup);
        bind(PopupType.BATTLE_RESULTS).toConstantValue(BattleResultsPopup);
        bind(PopupType.LEVEL_COMPLETED).toConstantValue(ShareLevelResultPopup);
        bind(PopupType.SETTINGS).toConstantValue(SettingsPopup);
        bind(PopupType.LOSE).toConstantValue(LosePopup);
        bind(PopupType.CONFIRM).toConstantValue(ConfirmPopup);
        bind(PopupType.GIFT).toConstantValue(GiftPopup);
        bind(PopupType.OFFLINE_EARNINGS).toConstantValue(OfflineEarningsPopup);
        bind(PopupType.PAYMENT_METHOD).toConstantValue(PaymentMethodPopup);
        bind(PopupType.NO_ADS_PURCHASE).toConstantValue(NoAdsPurchasePopup);
        bind(PopupType.REFERRAL_GIFT).toConstantValue(ReferralGiftPopup);
        bind(PopupType.DAILY_LEADERBOARD_REWARD).toConstantValue(DailyLeaderboardRewardPopup);
        bind(TypesGame.screens.referral).toConstantValue(ReferralScreen);
    }
);
